import { render } from "./TagsMini.vue?vue&type=template&id=3cfb4078"
import script from "./TagsMini.vue?vue&type=script&lang=js"
export * from "./TagsMini.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__